/* Single place to configure pdf.js for the whole app.
 *
 * Every component that renders a PDF (document preview, sign-on-document,
 * read-to-end) must import pdfjsLib from here instead of "pdfjs-dist"
 * directly, so that:
 *   1. the Map-upsert polyfill is installed before any pdf.js code runs, and
 *   2. one polyfilled module worker (GlobalWorkerOptions.workerPort) is
 *      shared by all documents — workerSrc would load the stock worker,
 *      which crashes without the polyfill (see mapUpsertPolyfill.ts).
 */
import "./mapUpsertPolyfill";

import * as pdfjsLib from "pdfjs-dist";

import PdfJsWorker from "./pdfWorkerEntry?worker";

if (!pdfjsLib.GlobalWorkerOptions.workerPort) {
  pdfjsLib.GlobalWorkerOptions.workerPort = new PdfJsWorker();
}

export { pdfjsLib };
